import { PolicyRegion } from '../types/policy-types';

export const getPolicyRegion = (
  entityCode: string,
  companyCode: string,
  policyNumber: string,
): PolicyRegion => {
  switch (entityCode) {
    case 'LHK':
      return 'HK';
    case 'LMA':
      return 'MA';
    case 'EHK':
      return companyCode === '5' ? 'MA' : 'HK';
    case 'GHK':
      // P&C
      return 'Both';
    case 'G4HK':
      // FC
      return 'Both';
    case 'UHK':
    case 'HHK': {
      if (policyNumber.startsWith('888')) {
        return 'HK';
      } else if (policyNumber.startsWith('828')) {
        return 'MA';
      }
      return 'Both';
    }
    default:
      console.warn(
        `Could not detect policy region for entityCode: ${entityCode}`,
      );
      return 'Both';
  }
};

export const getPoliciesRegion = (
  policies: {
    entityCode: string;
    companyCode: string;
    policyNumber: string;
  }[],
): PolicyRegion => {
  const result = new Set<PolicyRegion>();
  for (const policy of policies) {
    result.add(
      getPolicyRegion(
        policy.entityCode,
        policy.companyCode,
        policy.policyNumber,
      ),
    );
  }
  if (result.has('Both') || (result.has('HK') && result.has('MA'))) {
    return 'Both';
  } else if (result.has('MA')) {
    return 'MA';
  } else {
    return 'HK';
  }
};
